import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-callback',
  templateUrl: './callback.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule]
})
export class CallbackComponent {
  private authService = inject(AuthService);
  // AuthService procesa el callback (y limpia la URL) antes de que este componente se cree.
  readonly error = this.authService.callbackError;

  goHome(): void {
    window.location.href = window.location.origin;
  }
}
